// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BAButton--next-sr-only--gfwQMLh","BAButton":"BAButton--BAButton--2sytU7e","ItemText":"BAButton--ItemText--1SZfrZN"};